"use client";

import { Divider, Form } from "antd";

import { useGlobalNewOpportunityModalContext } from "../context";
import { useOpportunityForm } from "../hooks/useOpportunityForm";
import { useGlobalCreateOpportunityStore } from "../store";

import { Collapsable } from "./Collapsable";
import { CoreFields } from "./CoreFields";

export const OpportunityForm = () => {
  const { form, oppNameRef } = useGlobalNewOpportunityModalContext();

  const isOpportunityCreating = useGlobalCreateOpportunityStore(
    state => state.isOpportunityCreating,
  );

  const { onFinish } = useOpportunityForm();

  if (!form) {
    return null;
  }

  return (
    <Form
      disabled={isOpportunityCreating}
      layout="vertical"
      form={form}
      name="opportunityCreateForm"
      onFinish={onFinish}
      onFinishFailed={() => {
        oppNameRef?.current?.focus();
      }}
      validateTrigger={["onBlur"]}
    >
      <CoreFields />
      <Divider className="!my-0" />
      <Collapsable />
    </Form>
  );
};
